/**
 * useCatcherStats - Catcher station statistics
 *
 * Auto-refreshes every 30 seconds to show current counts.
 */
import { trpc } from '@/lib/trpc';
import { useLocation } from '@/contexts/LocationContext';
import { skipToken } from '@tanstack/react-query';

export function useCatcherStats() {
  const { selectedLocation } = useLocation();

  return trpc.catcher.getCatcherStats.useQuery(
    selectedLocation?.id
      ? { locationId: selectedLocation.id }
      : skipToken,
    {
      staleTime: 30_000, // 30s
      refetchInterval: 30_000, // Auto-refresh
    }
  );
}
